import { Box, SimpleGrid } from "@chakra-ui/react";
import { columnsDataDevelopment } from "views/admin/category/variables/columnsData";
import DynamicTable from "./DynamicTable";

export default function Settings() {
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ base: 1, md: 1, xl: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
<Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
  <DynamicTable
    columnsData={columnsDataDevelopment}
    endpoint="/categories"
  />
</Box>
      </SimpleGrid>
    </Box>
  );
}
